import { useFundRetrieveSuspense } from "gen/endpoints/fund-entities/fund-entities";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs, PageTabsStatus } from "shared/components/layout/PageTabs";
import { useFeatureFlagsActive } from "shared/hooks/useFeatureFlag";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const FundFamilySetupEntitiesEditPage: React.FC = () => {
  const { t } = useTranslation(["common", "entity"]);

  const { fundFamilyId, entityId } = useRequiredStringParams();

  const { data: entity } = useFundRetrieveSuspense(fundFamilyId, entityId);

  const featureFlags = useFeatureFlagsActive([
    "allow_creation_of_allocation_rule_graphs_via_ui",
    "use_allocation_rule_groups",
  ]);

  const isEitherFlagOn = useMemo(
    () =>
      featureFlags.get("allow_creation_of_allocation_rule_graphs_via_ui") ||
      featureFlags.get("use_allocation_rule_groups"),
    [featureFlags],
  );

  const hiddenTabs: PageTabsStatus = {
    fundFamilySetupEntitiesEntityAllocationsList: isEitherFlagOn,
  };

  return (
    <PageContent contentWidth="boxed">
      <PageHeader
        title={entity.legal_name}
        backButton={{
          title: t("common:fundEntities"),
          path: rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .entities({})
            .list({}).$,
        }}
      />
      <PageBody>
        <PageTabs context={{ fundFamilyId, entity }} hiddenTabs={hiddenTabs} />
      </PageBody>
    </PageContent>
  );
};
